import React from 'react';
import { ShieldCheckIcon, CheckCircleIcon } from 'lucide-react';
import { useModal } from '../App';
export function Guarantee() {
  const {
    openModal
  } = useModal();
  return <section className="py-20 md:py-32 bg-slate-900 relative overflow-hidden" data-id="element-169">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-full bg-amber-500/5 blur-[120px] rounded-full pointer-events-none" data-id="element-170"></div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10" data-id="element-171">
        <div className="inline-flex items-center justify-center w-32 h-32 rounded-full border-4 border-amber-500 bg-slate-800 mb-10 shadow-[0_0_30px_rgba(245,158,11,0.2)] relative" data-id="element-172">
          <ShieldCheckIcon className="h-16 w-16 text-amber-500" data-id="element-173" />
          <div className="absolute -bottom-3 -right-3 bg-amber-500 rounded-full p-1.5 border-4 border-slate-900" data-id="element-174">
            <CheckCircleIcon className="h-6 w-6 text-white" data-id="element-175" />
          </div>
        </div>

        <h2 className="text-4xl md:text-5xl lg:text-6xl font-extrabold text-white mb-8" data-id="element-176">
          The ProRoof Guarantee
        </h2>

        <p className="text-xl md:text-2xl text-slate-300 leading-relaxed mb-12 font-light" data-id="element-177">
          100% Satisfaction Guaranteed. Every ProRoof installation comes with
          our comprehensive workmanship warranty. If anything is not perfect, we
          will make it right — no questions asked. Your home deserves nothing
          less than the best.
        </p>

        <div className="flex flex-col md:flex-row items-center justify-center gap-4 md:gap-8 text-slate-400 font-medium mb-12" data-id="element-178">
          <span className="flex items-center gap-2" data-id="element-179">
            <CheckCircleIcon className="h-5 w-5 text-amber-500" data-id="element-180" />
            25-Year Manufacturer Warranty
          </span>
          <span className="hidden md:block text-slate-600" data-id="element-181">•</span>
          <span className="flex items-center gap-2" data-id="element-182">
            <CheckCircleIcon className="h-5 w-5 text-amber-500" data-id="element-183" />
            Lifetime Workmanship Warranty
          </span>
          <span className="hidden md:block text-slate-600" data-id="element-184">•</span>
          <span className="flex items-center gap-2" data-id="element-185">
            <CheckCircleIcon className="h-5 w-5 text-amber-500" data-id="element-186" />
            100% Satisfaction Promise
          </span>
        </div>

        <button onClick={openModal} className="bg-amber-500 hover:bg-amber-600 text-white px-10 py-5 rounded-xl font-bold text-xl transition-all transform hover:scale-105 shadow-xl shadow-amber-500/20" data-id="element-187">
          Schedule Your Free Inspection
        </button>
      </div>
    </section>;
}